export function parseFramesTxt(txt) {
  const frames = [];
  const lines = txt.split("\n");

  for (let line of lines) {
    line = line.trim();
    if (!line || line.startsWith("#")) continue;

    const parts = line.split(/\s+/);
    const frameId = Number(parts[0]);
    const rigId = Number(parts[1]);

    const qw = Number(parts[2]),
      qx = Number(parts[3]),
      qy = Number(parts[4]),
      qz = Number(parts[5]);
    const tx = Number(parts[6]),
      ty = Number(parts[7]),
      tz = Number(parts[8]);

    // sensors skip
    frames.push({ frameId, rigId, qw, qx, qy, qz, tx, ty, tz });
  }
  return frames;
}

export function parseImagesTxt(txt) {
  const images = {};
  const lines = txt.split("\n");

  for (let line of lines) {
    line = line.trim();
    if (!line || line.startsWith("#")) continue;

    const parts = line.split(/\s+/);
    const imgId = Number(parts[0]);

    const qw = Number(parts[1]),
      qx = Number(parts[2]),
      qy = Number(parts[3]),
      qz = Number(parts[4]);
    const tx = Number(parts[5]),
      ty = Number(parts[6]),
      tz = Number(parts[7]);
    const cameraId = Number(parts[8]);

    // name은 스페이스 포함하므로 slice
    const name = parts.slice(9).join(" ");

    images[imgId] = { imgId, qw, qx, qy, qz, tx, ty, tz, cameraId, name };
  }

  return images;
}

export function parsePoints3D(txt) {
  const points = [];
  const lines = txt.split("\n");

  for (let line of lines) {
    line = line.trim();
    if (!line || line.startsWith("#")) continue;

    const parts = line.split(/\s+/);

    const id = Number(parts[0]);
    const x = Number(parts[1]),
      y = Number(parts[2]),
      z = Number(parts[3]);
    const r = Number(parts[4]),
      g = Number(parts[5]),
      b = Number(parts[6]);
    const error = Number(parts[7]);

    const track = [];
    for (let i = 8; i < parts.length - 1; i += 2) {
      track.push({
        imageId: Number(parts[i]),
        point2dIdx: Number(parts[i + 1]),
      });
    }

    points.push({ id, x, y, z, r, g, b, error, track });
  }

  return points;
}
